import { FEEDBACK } from "../types/feedback";

export const setfeedback = (data) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: data,
  });
};
